











































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
import { CopyUrl } from "@/common/clipboard";
import EmptyCell from "@/components/EmptyCell.vue";
import { UsePopup } from "@/components/root/popup/popup.state";
import { remToPx } from "@/common/dom.functions";

export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
    EmptyCell,
  },
  setup(props) {
    const showMenu = (event: MouseEvent) => {
      EventBus.emit("showEntityMenu", { item: props.source, event });
    };

    const show_owners_as_popup = (event: MouseEvent, owners: string[]) => {
      UsePopup.showDisplayPopup({
        type: "TextDisplayPopup",
        event,
        items: owners,
        position: "left",
        width: remToPx(30),
      });
    };

    return {
      CopyUrl,
      showMenu,
      show_owners_as_popup,
    };
  },
});
